export default __webpack_public_path__ + "static/media/Gstaff_craft.9d6f3ac1.jpg";